import { NimmstaConnectionManager } from './NimmstaConnectionManager';
import { version } from '../../package.json';
export class NIMMSTA {
    static docReady() {
        NIMMSTA.isDocReady = true;
        if (NIMMSTA.onReadyListeners.length > 0 && !NIMMSTA.conManCreated) {
            NIMMSTA.conManCreated = true;
            new NimmstaConnectionManager();
        }
    }
    static onReady(fn) {
        if (NIMMSTA.isReady) {
            fn();
        }
        else {
            this.onReadyListeners.push(fn);
            if (NIMMSTA.isDocReady && NIMMSTA.connectionManager == null && !NIMMSTA.conManCreated) {
                NIMMSTA.conManCreated = true;
                new NimmstaConnectionManager();
            }
        }
    }
    static onError(fn) {
        if (NIMMSTA.lastError != null) {
            fn(NIMMSTA.lastError);
        }
        else {
            this.onErrorListeners.push(fn);
        }
    }
    static callReady() {
        if (!this.isReady) {
            this.isReady = true;
            this.lastError = null;
            this.onReadyListeners.forEach((fn) => {
                fn();
            });
            if (this.ready != null) {
                this.ready();
            }
        }
    }
    static callError(err) {
        this.lastError = err;
        this.onErrorListeners.forEach((fn) => {
            fn(err);
        });
    }
    static tryConnect() {
        var _a;
        (_a = NIMMSTA.connectionManager) === null || _a === void 0 ? void 0 : _a.tryConnect();
    }
}
NIMMSTA.isReady = false;
NIMMSTA.lastError = null;
NIMMSTA.onReadyListeners = [];
NIMMSTA.onErrorListeners = [];
NIMMSTA.isDocReady = false;
NIMMSTA.conManCreated = false;
NIMMSTA.websocketPort = 64693;
NIMMSTA.prefersWebsocketConnection = true;
NIMMSTA.version = version.slice(0, -2);
NIMMSTA.initializedByLoader = false;
NIMMSTA.requestSendTimeout = 1000;
NIMMSTA.maxCommunicationRetries = 3;
NIMMSTA.appTimeout = 15000;
NIMMSTA.keepAlwaysConnected = false;
if (window != null) {
    if (document.readyState === 'complete') {
        setTimeout(() => {
            NIMMSTA.docReady();
        }, 10);
    }
    else {
        window.addEventListener('load', (_) => {
            NIMMSTA.docReady();
        }, false);
    }
    window.addEventListener('focus', (_) => {
        NIMMSTA.tryConnect();
    }, false);
}
//# sourceMappingURL=data:application/json;base64,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